module.exports = __webpack_public_path__ + "static/media/work-7.9c7a94d6.jpg";